import { API_ROOT as BaseURL } from '../configs/api';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';
import { CASINO_ROOT as CasinoURL } from '../configs/api';
import { OPERATOR_ID, deckHerosApi, realGamesApi } from '../configs/const';
import { MASTER_ROOT as MasterURL } from '../configs/api';
// import * as Sentry from "@sentry/react";
// import * as constants from '../configs/const';

export function get(request, params, options) {
    let url = new URL(BaseURL + request);
    if (request.includes('sso/token') || request.includes('affiliate/signup/checkusername') || request.includes('affiliate/signup/checkmobile')) {
        options.headers = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'X-OP-KEY': OPERATOR_ID
        });
    } else if (request.includes(ReportsURL) && request.includes("maintenance")) {
        url = new URL(request);
        options.headers = new Headers({
            'Content-Type': 'application/json',
            'X-OP-KEY': OPERATOR_ID
        });
    } else if (request.toString() === "affiliate/auth/requestcaptcha") {
        options.headers = new Headers({
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "X-OP-KEY": OPERATOR_ID,
        });
    } else if (request.includes('affiliate/currency')) {
        // url = new URL(request);
        options.headers = new Headers({
            'Content-Type': 'application/json',
            'X-OP-KEY': OPERATOR_ID,
        });
    } else {

        const accessToken = JSON.parse(localStorage.getItem("userAuthDetail")).token;
        options.headers = new Headers({
            'Content-Type': 'application/json',
            'X-OP-KEY': OPERATOR_ID,
            'Authorization': 'Bearer ' + accessToken
        });
        if (request.toString().includes('casino/games/launch/') || request.toString().includes('casino/games/LOTUS') || request.toString().includes('casino/games/SUPERNOVA')) {
            url = new URL(CasinoURL + request);
        } else if (request.toString().includes('manage/events/catalog')) {
            url = new URL(MasterURL + request);
        } else if (request.includes(ReportsURL)) {
            url = new URL(request);
            options.headers = new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken,
                'X-OP-KEY': OPERATOR_ID
            });
        } else if (request.includes(deckHerosApi)) {
            url = new URL(request);
        }else if (request.includes(realGamesApi)) {
            url = new URL(request);
        }
    }

    if (params != null) {
        const keys = Object.keys(params)

        let temp = keys.length > 0 ? '?' : '';
        for (let i = 0; i < keys.length; i++) {
            temp += `${keys[i]}=${params[keys[i]]}${i === keys.length - 1 ? '' : '&'}`
        }
        url = url + temp;
    }
    // let startTime = new Date().getTime()
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'GET',
            headers: options.headers,
            crossDomain: true
        })
        .then((response) => response)
        .then((res) => {
            // let endTime = new Date().getTime();
            // if(endTime - startTime > 3000){
            //     Sentry.captureMessage('Response time Exceed 3 sec - time taken: ' + (endTime - startTime)/1000 + ' sec in api url: ' + url + ' on route: ' + window.location.pathname)
            // }
            if (res.status === 401) {
                if (url.href.includes(realGamesApi)) {
                    resolve({ hasError: true });
                } else {
                    localStorage.clear();
                    this.props.history.push("/auth")// resolve({hasError:true})
                }
            } else if (res.status !== 204 && res.status !== 404) {
                resolve(res);
            } else {
                resolve({ hasError: true })
            }
        })
        .catch((error) => {
            // Sentry.captureException(error)
            reject(error);
        });
    });
}

export function post(request, body, options) {
    var url = new URL(BaseURL + request);
    if (request.includes(ReportsURL)) {
        url = new URL(request);
        if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
            const accessToken = JSON.parse(localStorage.getItem("userAuthDetail")).token;
            options.headers = new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken,
                'X-OP-KEY': OPERATOR_ID
            });
        }
    } else if (request.includes(deckHerosApi)) {
        url = new URL(request);
        if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
            const accessToken = JSON.parse(localStorage.getItem("userAuthDetail")).token;
            options.headers = new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken,
                'X-OP-KEY': OPERATOR_ID
            });
        }
    }else if (request.includes(realGamesApi)) {
        url = new URL(request);
        if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
            const accessToken = JSON.parse(localStorage.getItem("userAuthDetail")).token;
            options.headers = new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken,
                'X-OP-KEY': OPERATOR_ID
            });
        }
    }
    else if (request.toString() === 'gamecontrol/sportcontrol' || request.toString() === 'gamecontrol/casinocontrol') {
        if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
            const accessToken = JSON.parse(localStorage.getItem("userAuthDetail")).token;
            options.headers.append('Authorization', 'Bearer ' + accessToken);
            options.headers.append('Content-Type', 'application/json');
            options.headers.append('X-OP-KEY', OPERATOR_ID);
        }
    } else if (request.toString() === 'affiliate/signup' || request.toString() === 'affiliate/forgetpassword/sendotp' || request.toString() === 'affiliate/signup/sendotp' || request.toString() === 'affiliate/forgetpassword') {
        options.headers = new Headers({
            'Content-Type': 'application/json',
            'X-OP-KEY': OPERATOR_ID
        });
    }
    else if (request.toString() === 'sso/auth' || request.toString() === 'affiliate/auth/authenticate') {
        options.headers = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'X-OP-KEY': OPERATOR_ID
        });
    } else if (request.toString() === 'feed/betfair/eventcontrol') {
        if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
            const accessToken = JSON.parse(localStorage.getItem("userAuthDetail")).token;
            options.headers = new Headers({
                'Content-Type': 'application/json',
                'X-OP-KEY': OPERATOR_ID,
                'Authorization': 'Bearer ' + accessToken
            });
        }
    }
    else {
        if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
            const accessToken = JSON.parse(localStorage.getItem("userAuthDetail")).token;
            options.headers = new Headers({
                'Content-Type': 'application/json',
                'X-OP-KEY': OPERATOR_ID,
                'Authorization': 'Bearer ' + accessToken
            });
        }
    }
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            body: body,
            headers: options.headers,
            crossDomain: true
        })
        .then((response) => response)
        .then((res) => {
            if (res.status === 401) {
                if (url.href.includes(realGamesApi)) {
                    resolve({ hasError: true });
                } else {
                    localStorage.clear();
                    this.props.history.push("/auth")// console.log(res)
                    // resolve({hasError:true})
                }
            } else if (res.status !== 204 && res.status !== 404) {
                resolve(res);
            } else {
                resolve({ hasError: true })
            }
        })
        .catch((error) => {
            // Sentry.captureException(error)
            reject(error);
        });
    });
}
export function put(request, body, options) {
    if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
        const accessToken = JSON.parse(localStorage.getItem("userAuthDetail")).token;
        options.headers = new Headers({
            'Content-Type': 'application/json',
            'X-OP-KEY': OPERATOR_ID,
            'Authorization': 'Bearer ' + accessToken
        });
    }
    return new Promise((resolve, reject) => {
        fetch(BaseURL + request, {
            method: 'PUT',
            body: body,
            headers: options.headers
        })
        .then((response) => response)
        .then((res) => {
            if (res.status === 401) {
                localStorage.clear();
                this.props.history.push("/auth")// console.log(res)
                // resolve({hasError:true})
            } else if (res.status !== 204 && res.status !== 404) {
                resolve(res);
            } else {
                resolve({ hasError: true })
            }
        })
        .catch((error) => {
            // Sentry.captureException(error)
            reject(error);
        });
    });
}
export function remove(request, options) {

    if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
        const accessToken = JSON.parse(localStorage.getItem("userAuthDetail")).token;
        options.headers = new Headers({
            'Content-Type': 'application/json',
            'X-OP-KEY': OPERATOR_ID,
            'Authorization': 'Bearer ' + accessToken
        });
    } else {
        options.headers = new Headers({
            'Content-Type': 'application/json'
        });
    }

    return new Promise((resolve, reject) => {
        fetch(BaseURL + request, {
            method: 'DELETE',
            headers: options.headers
        })
        .then((response) => response)
        .then((res) => {
            if (res.status === "401") {
                localStorage.clear();
                this.props.history.push("/auth")// console.log(res)
                // resolve({hasError:true})
            } else if (res.status !== 204 && res.status !== 404) {
                resolve(res);
            } else {
                resolve({ hasError: true })
            }
        })
        .catch((error) => {
            // Sentry.captureException(error)
            reject(error);
        });
    });
}